<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="fullPage" :z-index="zIndex"></loading>
    <b-modal id="modalDeleteCompetencie" ref="modalDeleteCompetencie" title="Confirm">
      <p>Do you really want to remove the registry?</p>
      <template slot="modal-footer">
          <b-button variant="primary" class="mr-2" @click="confirmDeleteCompetencie">Confirm</b-button>
          <b-button variant="secondary" @click="hideModalDeleteCompetencie">Close</b-button>
      </template>
    </b-modal>
    <b-modal id="modalAddCompetencie" ref="modalAddCompetencie" size="lg" title="Add Competencies, abilities and soft skills">
      <b-row>
        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
          <div class="form-group">
            <label>Think about your stronger competencies.</label>   
            <div class="input-group"> 
              <b-form-textarea id="textarea-default" v-model="competencie.description" rows="5" :state="$v.competencie.description.$dirty ? !$v.competencie.description.$error : null" maxlength="250"></b-form-textarea>
            </div>
          </div>
        </b-col>
      </b-row>
      <template slot="modal-footer">
          <b-button variant="primary" class="mr-2" @click="saveNewCompetencie">Save</b-button>
          <b-button variant="secondary" @click="hideModalAddCompetencie">Close</b-button>
      </template>
    </b-modal>
    <b-modal id="modalEditCompetencie" ref="modalEditCompetencie" size="lg" title="Edit Competencies, abilities and soft skills">
      <b-row>
        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
          <div class="form-group">
            <label>Think about your stronger competencies.</label>   
            <div class="input-group"> 
              <b-form-textarea id="textarea-default" v-model="competencie.description" rows="5" :state="$v.competencie.description.$dirty ? !$v.competencie.description.$error : null" maxlength="250"></b-form-textarea>
            </div>
          </div>
        </b-col>
      </b-row>
      <template slot="modal-footer">
          <b-button variant="primary" class="mr-2" @click="saveEditCompetencie">Save</b-button>
          <b-button variant="secondary" @click="hideModalEditCompetencie">Close</b-button>
      </template>
    </b-modal>
    <div class="card-body">
      <h5 class="card-title mt-4">Competencies, abilities and soft skills, please especify up to three.<span class="text-danger">*</span></h5>
      <div class="row">
        <div class="col-md-12">
          <b-table hover :items="competencies" :fields="competenciesFields">
            <template v-slot:cell(Description)="row">
              <div class="word-wrap">
                {{ row.item.description }}
              </div>
            </template>
            <template v-slot:cell(Options)="row">
              <b-button v-b-tooltip.hover title="Edit" variant="primary" size="xs" @click="editCompetencie(row.item)"><i class="far fa-edit"></i></b-button>
              <b-button v-b-tooltip.hover title="Remove" variant="danger" size="xs" class="ml-2" @click="deleteCompetencie(row.item)"><i class="far fa-trash-alt"></i></b-button>
            </template>
          </b-table>
          <b-button :disabled="competencies.length  >= 3" variant="primary" @click="addCompetencie" >Add competency</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appConfig from '@src/app.config'
import { authMethods } from '@state/helpers'
import loading from 'vue-loading-overlay'
import axios from 'axios'
import 'vue-loading-overlay/dist/vue-loading.css'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

var qs = require('qs')

export default {
  components: { loading },
  mixins: [validationMixin],
  props: {
    user: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    agency: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    id: { type: String, default: () => ({}) }
  },
  data () {
    return {
      CurriculumId: this.id,
      competencieOptions: [],
      competencieLevelOptions: [],
      competencie: {},
      competencies: [],
      competenciesFields: [
        {
          key: 'description',
          label: 'Description'
        },
        {
          key: 'Options',
          label: 'Options',
          thStyle: {width: '120px !important'}
        }
      ],
      isLoading: false,
      fullPage: false,
      zIndex: 9999,
      requiredFields: []
    }
  },
  validations() {
    return {
      competencie: {
        description : { required }
      }
    }
  },
  watch: {
    'education.onGoing': {
      handler: function (value) {
        if (value) {
          this.education.endDate = null
        }
      }
    }
  },
  created () {
    this.leadCompetencieLevels()
  },
  methods: {
    ...authMethods,
    leadCompetencieLevels () {
      this.isLoading = true
      axios.get(appConfig.apiUrl + 'competencie/proficiency',
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
        .then((response) => {
          if(response.data) {
            this.competencieLevelOptions = response.data
          }
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.loadCompetencies()
        })
    },
    addCompetencie () {
      this.competencie = {}
      this.$refs['modalAddCompetencie'].show()
    },
    saveNewCompetencie () {
      this.$v.competencie.$touch()
      if (this.$v.competencie.$anyError) {
        this.$notify({group: 'alert', type: 'error', title: 'Form Validation', text: 'Please complete all required fields.'});
        return
      }

      this.competencie.curriculumId = this.CurriculumId

      axios.post(appConfig.apiUrl + 'competencie/save',
        qs.stringify(this.competencie),
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.$notify({group: 'alert', type: 'success', title: 'Success', text: 'Saved Successful.'});
          this.loadCompetencies()
          this.hideModalAddCompetencie()
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'error', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.isLoading = false
        })

    },
    hideModalAddCompetencie () {
      this.$refs['modalAddCompetencie'].hide()
      this.$v.competencie.$reset()
    },
    editCompetencie (item) {
      this.competencie = item
      this.$refs['modalEditCompetencie'].show()
    },
    saveEditCompetencie () {
      axios.put(appConfig.apiUrl + 'competencie/update',
        qs.stringify(this.competencie),
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.$notify({group: 'alert', type: 'success', title: 'Success', text: 'Saved Successful.'});
          this.loadCompetencies()
          this.hideModalEditCompetencie()
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'error', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    hideModalEditCompetencie () {
      this.$refs['modalEditCompetencie'].hide()
      this.$v.competencie.$reset()
    },
    deleteCompetencie (item) {
      this.competencie = item
      this.$refs['modalDeleteCompetencie'].show()
    },
    confirmDeleteCompetencie () {
      this.isLoading = true

      axios.post(appConfig.apiUrl + 'competencie/delete',
        qs.stringify(this.competencie),
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.$notify({group: 'alert', type: 'success', title: 'Success', text: 'Deleted Successful.'});
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'error', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.loadCompetencies()
          this.isLoading = false
          this.hideModalDeleteCompetencie()
        })
    },
    hideModalDeleteCompetencie () {
      this.$refs['modalDeleteCompetencie'].hide()
    },
    loadCompetencies () {
      this.isLoading = true

      axios.get(appConfig.apiUrl + 'competencie/' + this.CurriculumId,
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
        .then((response) => {
          if(response.data) {
            this.competencies = response.data
          }
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
